<modal
  [modalId]="'notification-setup'"
  [modalSize]="'md'"
  (close)="modalCleanup()"
  [windowClass]="'notification-modal-dialog'">
  <div modal-title>
    <h3 class="d-inline text-capitalize" >
        <div class="custom-box-inner icon-button-inner">
              <img src="assets/icons/mark_email_unread.svg">
            <div class="custom-box-text">Setup Notifications</div>
        </div>
    </h3>
  </div>
  <div [formGroup]="form" class="modal-inner h-100 pt-3" modal-inner>
    <div class="notification-form-row">
        <div>Enable E-mail Notification</div>
        <label class="switch">
            <input type="checkbox" formControlName="enabled" name="enable-notifications">
            <span class="slider round"></span>
        </label>
    </div>
    <p class="notification-description">Subscribing to this mailing list will enable a single e-mail notification when the following criteria(s) are met:</p>
    <div class="notification-items">
        <div>Subscription Notifications</div>
        <div class="sub-notifications-grid" formGroupName="subscriptionNotifications">
            <input class="custom-select-check" type="checkbox" id="90-days" formControlName="ninetyDays">
            <label for="90-days">90 days left</label>
            <img src="assets/icons/warning.svg">

            <input class="custom-select-check" type="checkbox" id="30-days" formControlName="thirtyDays">
            <label for="30-days">30 days left</label>
            <img src="assets/icons/warning.svg" class="warning-severe">

            <input class="custom-select-check" type="checkbox" id="0-days" formControlName="zeroDays">
            <label for="0-days">Out of contract</label>
            <img src="assets/icons/do_not_disturb_on.svg">
        </div>
        <div>Allowance Notifications</div>
        <div class="allow-notifications-grid" formGroupName="allowanceNotifications">
            <input class="custom-select-check" type="checkbox" id="90-per" formControlName="ninetyPercent">
            <label for="90-per">
                <span class="warning-high">90%</span> of allowance used on any entity
            </label>

            <input class="custom-select-check" type="checkbox" id="100-per" formControlName="hundredPercent">
            <label for="100-per">
                <span class="warning-severe">100%</span> of allowance used on any entity
            </label>
        </div>
        <div class="submit-notification-changes">
            <button mat-stroked-button class="default-custom-button" (click)="closeModal()">Cancel</button>
            <button mat-flat-button class="add-button" [disabled]="!form?.valid || form?.pristine" (click)="submitForm()">Save</button>
        </div>
    </div>
  </div>
</modal>
